import { render, staticRenderFns } from "./AdverseEventsTable.vue?vue&type=template&id=594a9416&"
import script from "./AdverseEventsTable.vue?vue&type=script&lang=js&"
export * from "./AdverseEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports